export default __webpack_public_path__ + "static/media/logo-onboard-04.7321725e.png";